import _ from "lodash";
import { resolveStage } from "./stage";
import { Activity, ExtendedOrganizationDto } from "./types";

export const App = ["rmf", "aos", "pg-nego"] as const;
export type App = (typeof App)[number];

// --- TO SWITCH APPS, CHANGE THIS VALUE ---

export const app: App = (() => {
  if (process.env.REACT_APP_APP) {
    return process.env.REACT_APP_APP as App;
  }

  let urlApp = window.location.host.split(".")[0];
  if (urlApp.includes("-")) {
    urlApp = urlApp.split("-")[0];
  }
  if (App.includes(urlApp as App)) {
    return urlApp as App;
  }

  return "pg-nego";
})() as App;

// ----------------------------------------

export const appName = {
  rmf: "Retailer Money Flow",
  aos: "Art of Selling",
  "pg-nego": "Acme Corporation",
}[app];

export const faviconUrl = {
  rmf: "/rmf-favicon.ico",
  aos: "/aos-favicon.ico",
  "pg-nego": "/favicon.ico",
}[app];

export const getZetaUrl = (organizationIdentifier: string) => {
  return {
    local: "http://acme.nersio.localenv",
    development: `https://${organizationIdentifier}.zeta-v2.nersio.dev`,
    production: `https://${organizationIdentifier}.nersio.com`,
  }[resolveStage()] as string;
};

export const cmsHost = {
  rmf: "rmf",
  aos: "aos",
  "pg-nego": "pg-nego",
}[app];

export const cmsApiUrl = {
  local: `https://${cmsHost}.cms.nersio.dev/api`,
  development: `https://${cmsHost}.cms.nersio.dev/api`,
  production:
    app === "rmf"
      ? `https://cms.${cmsHost}.nersio.com/api`
      : `https://${cmsHost}.cms.nersio.com/api`,
}[resolveStage()] as string;

export const cmsApiToken = {
  local: {
    rmf: "7d990299f2a6c15183fbdf2441b4ebdadfb7fa92dc6ef7ebfdd4f3655354adcf27557bf8a77331c05fc84fab06792a313fdcd6ea0c19123a8a40eccac204c36ebfada87807812ba00205fd09c62f4fcdcfb00430a753f272e6895416b38d5795c7e3c758c74410265d904e31312018911ab154febe2c51519ea5de8986b7f2d3",
    aos: "0daf04c18243dc573a43ed5f009c1e3a0b2967294e5a41293c879e8dfb5bfedd6ddc8fd0d14f99c9786aec4d9cd34cb0b89fc377ee32ab2f0526218f0c1811533938fc02f0f27f0eaa72b200852f17d7b62c2690f5ee69687eb3dfab05a699ccc733e4c119bb57f41c02ea85f0b29ac1f1729363dd27c575b3f1003590cd794f",
    "pg-nego":
      "7d990299f2a6c15183fbdf2441b4ebdadfb7fa92dc6ef7ebfdd4f3655354adcf27557bf8a77331c05fc84fab06792a313fdcd6ea0c19123a8a40eccac204c36ebfada87807812ba00205fd09c62f4fcdcfb00430a753f272e6895416b38d5795c7e3c758c74410265d904e31312018911ab154febe2c51519ea5de8986b7f2d3",
  },
  development: {
    rmf: "7d990299f2a6c15183fbdf2441b4ebdadfb7fa92dc6ef7ebfdd4f3655354adcf27557bf8a77331c05fc84fab06792a313fdcd6ea0c19123a8a40eccac204c36ebfada87807812ba00205fd09c62f4fcdcfb00430a753f272e6895416b38d5795c7e3c758c74410265d904e31312018911ab154febe2c51519ea5de8986b7f2d3",
    aos: "0daf04c18243dc573a43ed5f009c1e3a0b2967294e5a41293c879e8dfb5bfedd6ddc8fd0d14f99c9786aec4d9cd34cb0b89fc377ee32ab2f0526218f0c1811533938fc02f0f27f0eaa72b200852f17d7b62c2690f5ee69687eb3dfab05a699ccc733e4c119bb57f41c02ea85f0b29ac1f1729363dd27c575b3f1003590cd794f",
    "pg-nego":
      "7d990299f2a6c15183fbdf2441b4ebdadfb7fa92dc6ef7ebfdd4f3655354adcf27557bf8a77331c05fc84fab06792a313fdcd6ea0c19123a8a40eccac204c36ebfada87807812ba00205fd09c62f4fcdcfb00430a753f272e6895416b38d5795c7e3c758c74410265d904e31312018911ab154febe2c51519ea5de8986b7f2d3",
  },
  production: {
    rmf: "7d990299f2a6c15183fbdf2441b4ebdadfb7fa92dc6ef7ebfdd4f3655354adcf27557bf8a77331c05fc84fab06792a313fdcd6ea0c19123a8a40eccac204c36ebfada87807812ba00205fd09c62f4fcdcfb00430a753f272e6895416b38d5795c7e3c758c74410265d904e31312018911ab154febe2c51519ea5de8986b7f2d3",
    aos: "0daf04c18243dc573a43ed5f009c1e3a0b2967294e5a41293c879e8dfb5bfedd6ddc8fd0d14f99c9786aec4d9cd34cb0b89fc377ee32ab2f0526218f0c1811533938fc02f0f27f0eaa72b200852f17d7b62c2690f5ee69687eb3dfab05a699ccc733e4c119bb57f41c02ea85f0b29ac1f1729363dd27c575b3f1003590cd794f",
    "pg-nego":
      "7d990299f2a6c15183fbdf2441b4ebdadfb7fa92dc6ef7ebfdd4f3655354adcf27557bf8a77331c05fc84fab06792a313fdcd6ea0c19123a8a40eccac204c36ebfada87807812ba00205fd09c62f4fcdcfb00430a753f272e6895416b38d5795c7e3c758c74410265d904e31312018911ab154febe2c51519ea5de8986b7f2d3",
  },
}[resolveStage()][app] as string;

export const loginHost = {
  rmf: "pg",
  aos: "pg",
  "pg-nego": "acme",
}[app];

export const loginUrl = `${getZetaUrl(
  loginHost
)}/login?redirectTo=${encodeURIComponent(window.location.href)}`;

export const getCourseUrl = (
  activity: Activity,
  organization: ExtendedOrganizationDto
) => {
  return `${getZetaUrl(organization.slug)}/courses/${
    activity.resource.slug
  }`;
};

export const getActivityUrl = (
  activity: Activity,
  organization: ExtendedOrganizationDto
) => {
  return `${getZetaUrl(organization.slug)}/courses/${
    activity.resource.slug
  }/activities/${activity.id}`;
};

export const getModules = (activity: Activity) => {
  // debugger;
  if (app === "rmf") {
    if (
      _.get(activity, "resource.spec.experience.attributes.delivery") ===
        "facilitator-led" ||
      _.get(activity, "resource.spec.experience.delivery") === "facilitator-led"
    ) {
      return ["M0", "M1", "M2", "M3"];
    } else {
      return ["M0-SL", "M1-SL", "M2-SL"];
    }
  }

  if (app === "aos") {
    return ["M0", "M1", "M2", "M3"];
  }

  return ["M0", "M1", "M2", "M3"];
};
